import { useSearchParams } from "react-router-dom";

export default function AppAlertBanner({}) {
  const [searchParams, setSearchParams] = useSearchParams();

  if (searchParams.get("type") === "sessionTimeOut") {
    return (
      <div className="h-10 flex justify-center justify-items-center bg-ui-yellow-light text-center ">
        <svg
          className="ui-icon w-4 h-4 mr-2 self-center text-ui-yellow"
          focusable="false"
          aria-hidden="true"
          role="presentation"
        >
          <use href="#ui-icon-circle-solid-exclamation"></use>
        </svg>
        <p className="self-center text-ui-yellow font-semibold">
          You have been securely logged out due to inactivity
        </p>
      </div>
    );
  }

  return;
}
